export default class Formation {
  id: string;

  description: string;

  hiring: string;

  junior: string;

  plain: string;

  senior: string;

  active: boolean;

  objective: boolean;

  isApproved: boolean;

  observation: string;

  isNew: boolean = false;

  loadingIsApproved: boolean = false;

  loadingRejected: boolean = false;

  loadingObservation: boolean = false;

  idTemporary: string | null = null;

  expanded: number | null = null;

  constructor(obj: any = {}) {
    this.id = obj.id || null;
    this.description = obj.description || '';
    this.hiring = obj.hiring || 'RECOMMENDED';
    this.junior = obj.junior || 'RECOMMENDED';
    this.plain = obj.plain || 'RECOMMENDED';
    this.senior = obj.senior || 'RECOMMENDED';
    this.active = obj.active === undefined ? true : obj.active;
    this.objective = obj.objective || '';
    this.isApproved = obj.isApproved;
    this.observation = obj.observation || '';
    this.isNew = obj.isNew || false;
    this.loadingIsApproved = obj.loadingIsApproved || false;
    this.loadingRejected = obj.loadingRejeceted || false;
    this.loadingObservation = obj.loadingObservation || false;
    this.idTemporary = obj.idTemporary || null;
    this.expanded = obj.expanded;
  }

  public static ofNew() {
    return new Formation(
      {
        isNew: true,
        idTemporary: new Date().getTime().toString(),
        isApproved: null,
        active: true,
        expanded: 0,
      },
    );
  }
}
